import config from "@/config";
import { Transition } from "@headlessui/react";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { XIcon } from "lucide-react";
import { Fragment, useEffect, useState } from "react";
import useTranslation from "@babackapp/translations/use-translation";

export default function ShopifyScopeBanner({
  shopifyUrl,
}: {
  shopifyUrl: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const t = useTranslation();
  useEffect(() => {
    setTimeout(() => {
      setIsOpen(true);
    }, 1000);
  }, []);

  const onClose = () => {
    setIsOpen(false);
  };

  // if (config.isDev) return null;

  return (
    <Transition
      show={isOpen}
      as={Fragment}
      enter="transition ease-in-out duration-250"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition ease-in-out duration-250"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="bg-orange-500 text-white fixed top-0 left-0 right-0 h-16 z-100 flex flex-row justify-center items-center space-x-4 px-4">
        <div className="flex-1 flex flex-row justify-center items-center space-x-4">
          <div>{t("errors.shopifyScopeBanner.message")}</div>
          <button
            type="button"
            className="inline-flex justify-center items-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-white text-base font-medium text-orange-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2  sm:text-sm space-x-2"
            onClick={() =>
              (document.location.href = `${import.meta.env.VITE_API_URL}/app/auth?shop=${shopifyUrl}`)
            }
          >
            <div>{t("errors.shopifyScopeBanner.reconnectButton")}</div>
            <ArrowRightIcon className="w-4 h-4" />
          </button>
        </div>
        <button onClick={onClose} className="">
          <XIcon className="w-4 h-4" />
        </button>
      </div>
    </Transition>
  );
}
